import { z } from 'zod';

import { dashboardT } from '../../../lib/messages';
import { SchainType, type SchainList, type SchainListMutationPayload } from './model';

const required = () =>
  z
    .string()
    .trim()
    .min(1, { error: () => dashboardT('lists.validation.required') });

export const schainFormSchema = z.object({
  name: required(),
  type: z.enum(SchainType),
  enableRotationForDuplicateBundles: z.boolean(),
});

export type SchainFormValue = z.infer<typeof schainFormSchema>;

export const defaultSchainFormValue: SchainFormValue = {
  name: '',
  type: SchainType.Bundle,
  enableRotationForDuplicateBundles: false,
};

export function schainListToFormValue(item: SchainList): SchainFormValue {
  return {
    name: item.name,
    type: item.type,
    enableRotationForDuplicateBundles: item.enableRotationForDuplicateBundles,
  };
}

export function serializeSchainFormValue(
  value: SchainFormValue,
  base?: SchainList,
): SchainListMutationPayload {
  return {
    name: value.name.trim(),
    type: value.type,
    enableRotationForDuplicateBundles: value.enableRotationForDuplicateBundles,
    schainBundleList: base?.schainBundleList ?? [],
  };
}

export function schainExportFilename(name: string) {
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return `${slug || 'schain-list'}.csv`;
}
